class AppInfoModel {
  constructor({
    first_installation_time = null,
    id = null,
    installation_id = null,
    install_referrer = null,
    last_update_time = null,
    version = null,
  } = {}) {
    this.first_installation_time = first_installation_time;
    this.id = id;
    this.installation_id = installation_id;
    this.install_referrer = install_referrer;
    this.last_update_time = last_update_time;
    this.version = version;
  }

  json() {
    return {
      first_installation_time: this.first_installation_time,
      id: this.id,
      installation_id: this.installation_id,
      install_referrer: this.install_referrer,
      last_update_time: this.last_update_time,
      version: this.version,
    };
  }
}

module.exports = AppInfoModel;
